module.exports = __webpack_public_path__ + "static/img/fellowChicken1.be0a414.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fellowChicken1.png
// module id = Oftd
// module chunks = 2